import { buildSkillStep } from "@/core/skillForms/builder";
import { Area } from "@/contexts/MessagesContext";

export const createStrategySkillStep1 = buildSkillStep({
  description:
    "O Assistente Lexter pode te ajudar a identificar e selecionar as estratégias mais relevantes para o seu caso. Para iniciar, selecione a área jurídica de interesse.",
  title: "Area jurídica",

  fields: [
    {
      name: "area",
      type: "string",
      options: [
        { label: "Cível", value: Area.CIVIL },
        { label: "Trabalhista", value: Area.LABOR },
        { label: "Previdenciário", value: Area.SOCIAL_SECURITY },
        { label: "Tributário", value: Area.TAX },
        { label: "Criminal", value: Area.CRIMINAL },
        {
          label: "Outros",
          value: Area.OTHER,
        },
      ],
      ui: {
        label: "Área jurídica",
        placeholder: "Selecione a área",
      },
    },
    {
      name: "custom_area",
      type: "string",
      overrideField: "area",
      ui: {
        label: "Digite a área jurídica:",
        placeholder: "Exemplos: Direito Ambiental, Direito Administrativo...",
        widget: "textarea",
      },
      condition: {
        field: "area",
        value: Area.OTHER,
      },
    },
  ],
});
